import React from 'react';
import { ArticleDraft } from '@/hooks/useArticleDrafts';
import { DraftCard } from './DraftCard';

interface DraftsListProps {
  drafts: ArticleDraft[];
  isLoading: boolean;
  error: unknown;
  onApprove: (draftId: string) => void;
  onReject: (draftId: string, reason: string) => void;
}

export const DraftsList: React.FC<DraftsListProps> = ({
  drafts,
  isLoading,
  error,
  onApprove,
  onReject,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <p className="ml-4 text-muted-foreground">Laster utkast...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4 text-destructive">
        Kunne ikke laste utkast: {error instanceof Error ? error.message : 'Ukjent feil'}
      </div>
    );
  }

  if (drafts.length === 0) {
    return (
      <div className="bg-muted rounded-lg p-8 text-center">
        <p className="text-muted-foreground text-lg">
          Ingen utkast venter på godkjenning
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {drafts.map((draft) => (
        <DraftCard
          key={draft.id}
          draft={draft}
          onApprove={onApprove}
          onReject={onReject}
        />
      ))}
    </div>
  );
};
